<app-guest-mode-login
    [customerLanding]="data.customerLanding"
    [accessMode]="data.accessMode"
    (onLoggedIn)="bottomSheetRef.dismiss(true)"
></app-guest-mode-login>
